<template>
    <div class="transfer-list-container" :style="{ padding: paddingContainer }">
        <div class="container-list" :style="{ minHeight: containerMinHeight, height: containerHeight }">
            <div class="transfer-list-header">
                <div class="title" :style="{ background: bgTitle, padding: titlePadding }">
                    <ui-lock-icon v-if="iconOrigin" :design="'mr7px'" />
                    <span :style="{ fontSize: titleFontSize }">{{ originMessage }}</span>
                </div>
                <div v-if="inputContainer" class="input-container">
                    <input :value="searchOrigin" :placeholder="searchMessage" class="input-transfer"
                        @input="onOriginInput" />
                    <em class="fal fa-search"></em>
                </div>
                <slot name="originAction" />
            </div>
            <perfect-scrollbar>
                <slot name="sourceList" class="list scroll-color-primary">
                </slot>
            </perfect-scrollbar>
            <div v-if='originsList' class="origin-list-container">
                <slot name="originLists" />
            </div>
        </div>

        <div class="actions">
            <button class="circle" :class="[
                    actionsDisable ? 'disabled' : '',
                    activeRightAction ? 'active' : ''
                ]
                " :disabled="actionsDisable || actionsDisableRight" @click="toRightAction">
                <em class="fal fa-chevron-right"></em>
            </button>
            <button class="circle" :class="[
                    actionsDisable ? 'disabled' : '',
                    activeLeftAction ? 'active' : ''
                ]
                " :disabled="actionsDisable || actionsDisableLeft" @click="toLeftAction">
                <em class="fal fa-chevron-left"></em>
            </button>
        </div>

        <div class="container-list" :style="{ minHeight: containerMinHeight, height: containerHeight }">
            <div class="transfer-list-header">
                <div class="title open" :style="{ padding: titlePadding }">
                    <ui-open-lock-icon v-if="iconTarget" :design="'mr7px'" />
                    <span :style="{ fontSize: titleFontSize }">{{ targetMessage }}</span>
                </div>
                <div v-if="inputContainer"  class="input-container">
                    <input :value="searchTarget" :placeholder="searchMessage" class="input-transfer"
                        @input="onTargetInput" />
                    <em class="fal fa-search"></em>
                </div>
                <slot name="targetAction" />
            </div>
            <div v-if="isPagination">
                <slot name="targetList" class="list scroll-color-primary" />
            </div>
            <perfect-scrollbar v-else>
                <slot name="targetList" class="list scroll-color-primary" />
            </perfect-scrollbar>
            <div v-if="targetLists" class="target-list-container">
                <slot name="targetLists" />
            </div>
        </div>
    </div>
</template>


<script>


export default {
    name: 'ui-transfer-list',
    components: {
    },
    props: {
        actionsDisable: {
            type: Boolean,
            default: false
        },
        searchOrigin: {
            type: String,
            default: ''
        },
        searchTarget: {
            type: String,
            default: ''
        },
        originMessage: {
            type: String,
            default: ''
        },
        targetMessage: {
            type: String,
            default: ''
        },
        searchMessage: {
            type: String,
            default: ''
        },
        toLeftAction: {
            type: Function,
            default: () => { }
        },
        toRigthDisabled: {
            type: Boolean,
            default: false
        },
        toLeftDisabled: {
            type: Boolean,
            default: false
        },
        toRightAction: {
            type: Function,
            default: () => { }
        },
        bgTitle: {
            type: String,
            default: '#9CA8B0'
        },
        iconOrigin: {
            type: Boolean,
            default: true
        },
        iconTarget: {
            type: Boolean,
            default: true
        },
        inputContainer: {
            type: Boolean,
            default: true
        },
        activeLeftAction: {
            type: Boolean,
            default: false
        },
        activeRightAction: {
            type: Boolean,
            default: false
        },
        actionsDisableLeft: {
            type: Boolean,
            default: false
        },
        actionsDisableRight: {
            type: Boolean,
            default: false
        },
        containerMinHeight: {
            type: String,
            default: '370px'
        },
        isPagination: {
            type: Boolean,
            default: false
        },
        originsList: {
            type: Boolean,
            default: false
        },
        targetLists: {
            type: Boolean,
            default: false
        },
        paddingContainer: {
            type: String,
            default: '25px 30px 45px 30px'
        },
        titlePadding: {
            type: String,
            default: '21px 20px'
        },
        titleFontSize: {
            type: String,
            default: '16px'
        },
        containerHeight:{
            type: String,
            default: '100%'
        }

    },
    data() {
        return {
        }
    },
    computed: {

    },
    methods: {
        onOriginInput(event) {
            this.$emit('update:searchOrigin', event.target.value);
        },
        onTargetInput(event) {
            this.$emit('update:searchTarget', event.target.value);
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
